import React from "react";
import { Tabs } from "antd";
import classNames from "classnames";
import DingtalkShare from "../DingtalkShare";
import "./DingtalkSharePanel.scss";
import { isDTRuntime } from "@/modules/dingtalk/dingtalk.sdk";

const { TabPane } = Tabs;

export const dingtalkShareTabPaneKey = 'dingtalkSharePanel';
export function genDingtalkSharePanel({ activeTabKey, success }) {
    if (!isDTRuntime) return null;
    return (
        // @ts-ignore
        <TabPane
            tab={<DingtalkShareTabTitle active={activeTabKey === dingtalkShareTabPaneKey} />}
            key={dingtalkShareTabPaneKey}
        >
            <DingtalkShare success={success}></DingtalkShare>
        </TabPane>
    )
}

function DingtalkShareTabTitle({
    active
}) {
    return (
        <div className={classNames('dd-share__tab-title', active ? 'active' : '')}>
        </div>
    )
}
